type CostProfile = {
  name: string;
  description: string;
  cost?: number;
};

const costProfile: CostProfile = {
  name: "",
  description: "",
};

export type { CostProfile };

export { costProfile };
